import request from '@/utils/request'
import axios from "axios";
import {mockableLinks} from "@/constants/config";
import { reactive } from "vue";


export function getTimeZones() {  
  return axios.get('/timezones.json', { baseURL: window.location.origin})
  .then((response) => { return response; })
  .catch((error) => {
      throw error.response.data;
  }); 
}

export function getcountries() {
  //return request({ url: 'publicdata/countries', method: 'get'})

  //return axios.get('/countries.json')




  return axios.get('/countries.json', { baseURL: window.location.origin})
  .then((response) => { return response; })
  .catch((error) => {
      throw error.response.data;
  });

}
export function getcities(country_id) {
  return request({ url: 'publicdata/cities?countryid=' + country_id, method: 'get'})
}

export function getaccountlist() {
  return request({ url: 'vgetaccountlist', method: 'get'})
}


export function getjobclassifications() {
  //return request({ url: 'publicdata/jobclassifications', method: 'get'})

  return axios.get('/jobclassification.json', { baseURL: window.location.origin})
  .then((response) => { return response; })
  .catch((error) => {
      throw error.response.data;
  });
}
 


export function getoviage(params) {
  return request({ url: 'publicdata/getoviage', method: 'post', data: params })
} 





export function resetLocalCache(){
  for(let ctr = 0; ctr < mockableLinks.length; ctr++){
    let url = mockableLinks[ctr].url;

    if(url !== "vgetaccountlist"){
      localStorage.removeItem(url + "_local_data_timestamp");
      localStorage.removeItem(url + "_local_data");
    }
    
  }
}




export const ecShopAdvisoryVisibility = reactive({
  showComponent: true, // Default hidden
  toggle() {
    this.showComponent = !this.showComponent; // Toggle visibility
  },
  hide() {
    this.showComponent = false; // Hide component
  },
  show() {
    this.showComponent = true; // Show component
  }
});